import React from 'react';
import { MessageCircle } from 'lucide-react';

const WA_NUMBER = "918800461522";

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${WA_NUMBER}?text=Hi%20KarmaCircle!%20I'd%20like%20to%20know%20more%20about%20your%20karma%20programs.`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 left-6 z-50 bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full p-3.5 shadow-lg shadow-[#25D366]/30 hover:-translate-y-1 transition-all duration-200 group"
      title="Chat with us on WhatsApp"
    >
      <MessageCircle className="w-6 h-6" strokeWidth={2} />
      <span className="absolute left-full ml-3 top-1/2 -translate-y-1/2 bg-[#1A1008] text-[#F5E6C8] font-sans text-xs font-medium px-3 py-1.5 rounded-lg border border-[#3D2D1D] whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat on WhatsApp
      </span>
    </a>
  );
}
